<template>
  <div>
    <div class="box info-box" v-if="this.$store.state.user.type == 'admin'">
      <div class="box-header with-border">
        Filter By
      </div>
      <div class="box-body">
        <div class="row">
          <div class="col-md-3">
            <label for="Branch">Branch</label>
            <v-select v-model="branch" name="branch_id" label="name" :options="branches" placeholder="Select Branch" v-on:input="profitLossRecord()"></v-select>
            
            <has-error
              :form="form"
              field="staff_id"
            ></has-error>
          </div>
          <!-- <div class="col-md-3">
            <label for="date">Start Date</label>
            <input type="date" v-model="startDate" name="startDate" class="form-control" @change="selectBetweenDate" placeholder="EMI Start Date">
          </div>
          <div class="col-md-3">
            <label for="date">End Date</label>
            <input type="date" v-model="endDate" name="endDate" class="form-control" @change="selectBetweenDate" placeholder="EMI End Date">
          </div> -->
        </div>
      </div>
      <!-- /.box-body -->
    </div>
    <div class="box info-box">
      <div class="box-header with-border">
          <h3 class="box-title text-warning">Profit-Loss</h3>
      </div>
      <!-- /.box-header -->
      <div class="box-body">
        <div class="row">
          <div class="col-md-6">
            <h2>Income</h2>
            <p><strong>Indirect Income : {{indInc}}</strong></p>
            <table class="table table-sm table-bordered table-striped table-hover">
            <tbody>
              <tr v-for="(item, index) in indirectIncomeRecords" :key="item.id">
                <td>{{index + 1}}</td>
                <td>{{item.name}}</td>
                <td>
                  <div v-if="item.br_ledgers">
                    <div v-for="item_ledger in item.br_ledgers" :key="item_ledger.id">
                      <!-- <li v-if="item_ledger.cr_amt || item_ledger.dr_amt"> -->
                        <table v-if="item_ledger.cr_amt || item_ledger.dr_amt" class="table">
                          <thead>
                            <th class="text-center" colspan="2" v-if="item_ledger.branch">Branch : <strong>{{item_ledger.branch.name}}</strong></th>
                          </thead>
                          <tbody>
                            <tr>
                              <td>Opening Balance :<span v-if="item_ledger.fy_opening_balance">  {{item_ledger.fy_opening_balance.openingBalance}}</span><span v-else> 0</span></td>
                              <td>Dr :<span v-if="item_ledger.dr_amt">  {{item_ledger.dr_amt}}</span><span v-else> 0</span></td>
                              <td>Cr :<span v-if="item_ledger.cr_amt">  {{item_ledger.cr_amt}}</span><span v-else> 0</span></td>
                            </tr>
                          </tbody>
                        </table>
                        <!-- <span v-if="item_ledger.branch"> <strong>{{item_ledger.branch.name}}</strong></span>
                        <span v-if="item_ledger.cr_amt"><br> Cr : {{item_ledger.cr_amt}}</span>
                        <span v-if="item_ledger.dr_amt"><br> Dr : {{item_ledger.dr_amt}}</span> -->
                      <!-- </li> -->
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          </div>
          <div class="col-md-6">
            <h2>Expense</h2>
            <p><strong>Indirect Expense : {{indExp}}</strong></p>
            <table class="table table-sm table-bordered table-striped table-hover">
            <tbody>
              <tr v-for="(item, index) in indirectExpenseRecords" :key="item.id">
                <td>{{index + 1}}</td>
                <td>{{item.name}}</td>
                <td>
                  <div v-if="item.br_ledgers">
                    <ul v-for="item_ledger in item.br_ledgers" :key="item_ledger.id">
                      <li><span v-if="item_ledger.branch"> <strong>{{item_ledger.branch.name}}</strong></span> <span v-if="item_ledger.cr_amt"><br> Cr : {{item_ledger.cr_amt}}</span> <span v-if="item_ledger.dr_amt"><br> Dr : {{item_ledger.dr_amt}}</span></li>
                    </ul>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          </div>
        </div>
          <!-- <table class="table table-sm table-bordered table-striped table-hover">
            <thead>
              <tr>
                <td>Direct Income</td>
                <td>{{indInc}}</td>
                <td>Direct Expense</td>
                <td>{{indExp}}</td>
              </tr>
              <tr>
                <td>Total Income</td>
                <td>{{indInc}}</td>
                <td>Total Expense</td>
                <td>{{indExp}}</td>
              </tr>
            </thead>
          </table> -->
                
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'profitloss',
  data () {
    return {
      isLoading: false,
      indInc: 0,
      startDate: '',
      endDate: '',
      indExp: 0,
      plRecords: '',
      indirectIncomeRecords: [],
      indirectExpenseRecords: [],
      branch_id: '',
      branch: {},
      branches: [],
      form: new Form({

      })
    }
  },
  methods: {
    selectBetweenDate () {
      if (this.startDate && this.endDate) {
        this.profitLossRecord()
      } else if (this.startDate === '' && this.endDate === '') {
        this.profitLossRecord()
      }
    },
    loadBranch () {
      this.$axios
        .get('branch?all=all&status=active', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.branches = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    profitLossRecord () {
      var ii = 0
      var ie = 0
      var indirectIncome = []
      var indirectExpense = []
      var c = JSON.parse(localStorage.user)
      if (c.type === 'staff') {
        this.branch_id = c.agent_profile.branch_id
      }
      // alert('hello')
      var pageUrl = ''
      pageUrl += 'profitloss?all=all'
      if (this.branch.id) {
        pageUrl += `&branch_id=${this.branch.id}`
      }
      if (this.startDate) {
        pageUrl += `&startDate=${this.startDate}`
      }
      if (this.endDate) {
        pageUrl += `&endDate=${this.endDate}`
      }
      if (c.type === 'admin') {
        this.$axios
        .get(pageUrl, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          indirectExpense = data[2]
          indirectIncome = data[3]
          this.indirectExpenseRecords = indirectExpense.ledgers
          this.indirectIncomeRecords = indirectIncome.ledgers
          _.forEach(indirectIncome.ledgers, function (value, key) {
            ii += _.sumBy(value.br_ledgers, function (o) { return o.cr_amt })
          })
          this.indInc = ii
          _.forEach(indirectExpense.ledgers, function (value, key) {
            ie += _.sumBy(value.br_ledgers, function (o) { return o.dr_amt })
          })
          this.indExp = ie
        })
        .catch(function (error) {
          console.log(error)
        })
      }
    }
  },
  created () {
    this.profitLossRecord()
    this.loadBranch()
  }
}
</script>
<style scoped>
.info-box {
    border-radius:10px;
    box-shadow: 0px 0px 4px gray;
  }
</style>



// WEBPACK FOOTER //
// ProfitLoss.vue?3cbf55bb